import { useConsent } from '@/lib/consent';
import { isAdalyserConfigured } from './client';

export const useAdalyserEnabled = (): boolean => {
  const { allowed } = useConsent();
  return allowed && isAdalyserConfigured();
};
